import { render, staticRenderFns } from "./links-section.vue?vue&type=template&id=12148ce5&scoped=true&"
import script from "./links-section.vue?vue&type=script&lang=js&"
export * from "./links-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12148ce5",
  null
  
)

export default component.exports